/**
 * Type guard function that checks if a value is a Uint8Array.
 * Returns true if the value is a Uint8Array, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a Uint8Array, false otherwise
 *
 * @example
 * ```ts
 * import { BytesQ } from "@pdfking/structs"
 *
 * BytesQ(new Uint8Array([1, 2, 3])) // true
 * BytesQ([1, 2, 3]) // false
 * ```
 */
export const BytesQ = <T>(value: T): value is Uint8Array & T => value instanceof Uint8Array
